import { MimeType } from '../file/mime-types';

/**
 * Extend this list if additional document types must be supported
 * When adding a mime type in here, make sure to also add the corresponding preview renderer to FilePreview.tsx if desired.
 */
export const SUPPORTED_DOCUMENT_MIME_TYPES = [MimeType.PDF, MimeType.MicrosoftWordOpenXML];
